import Navbar from '../Components/SolarComponents/Navbar'
import Hero from '../Components/SolarComponents/Hero'
import Stats from '../Components/SolarComponents/Stats'
import About from '../Components/SolarComponents/About'
import Services from '../Components/SolarComponents/Services'
import Testimonial from '../Components/SolarComponents/Testimonial'
import Blog from '../Components/SolarComponents/Blog'
import Contact from '../Components/SolarComponents/Contact'
import Footer from '../Components/SolarComponents/Footer'

function Solar() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <Services />
      <Testimonial />
      <Blog />
      <Contact />
      <Footer />
    </div>
  )
}

export default Solar
